var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProspectQ4M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 61.6666C11.7614 58.3688 9.20981 54.4608 7.49321 50.1693C5.7766 45.8778 4.92913 41.2882 4.99995 36.6666C4.99995 27.384 8.68744 18.4817 15.2512 11.9179C21.815 5.35412 30.7174 1.66663 39.9999 1.66663C49.2825 1.66663 58.1849 5.35412 64.7487 11.9179C71.3125 18.4817 74.9999 27.384 74.9999 36.6666C75.1017 45.9941 71.5063 54.9824 65 61.6666H14.9999Z",
    fill: "#F09F9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 16.6666C47.9977 16.6684 55.7535 19.4091 61.9766 24.4325C68.1997 29.456 72.5147 36.4593 74.2033 44.2766C74.7273 41.7737 74.9943 39.2238 75 36.6666C75 27.384 71.3125 18.4817 64.7487 11.9179C58.185 5.35412 49.2826 1.66663 40 1.66663C30.7174 1.66663 21.815 5.35412 15.2513 11.9179C8.68749 18.4817 5 27.384 5 36.6666C5.0044 39.2346 5.26909 41.7954 5.79 44.31C7.47224 36.4853 11.7854 29.4736 18.0105 24.4434C24.2356 19.4132 31.9966 16.6685 40 16.6666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 61.6666C11.7614 58.3688 9.20981 54.4608 7.49321 50.1693C5.7766 45.8778 4.92913 41.2882 4.99995 36.6666C4.99995 27.384 8.68744 18.4817 15.2512 11.9179C21.815 5.35412 30.7174 1.66663 39.9999 1.66663C49.2825 1.66663 58.1849 5.35412 64.7487 11.9179C71.3125 18.4817 74.9999 27.384 74.9999 36.6666C75.1017 45.9941 71.5063 54.9824 64.9999 61.6666H14.9999Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 61.6666H65L69.8366 73.7633C70.0386 74.2689 70.1137 74.8162 70.0553 75.3575C69.9969 75.8988 69.8068 76.4176 69.5016 76.8684C69.1964 77.3193 68.7855 77.6885 68.3046 77.9439C67.8238 78.1993 67.2877 78.3329 66.7433 78.3333H13.2566C12.7122 78.3329 12.1761 78.1993 11.6953 77.9439C11.2145 77.6885 10.8035 77.3193 10.4983 76.8684C10.1931 76.4176 10.0031 75.8988 9.94465 75.3575C9.88625 74.8162 9.96132 74.2689 10.1633 73.7633L15 61.6666Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6667 68.3333L65 61.6666H15L12.3334 68.3333H67.6667Z",
    fill: "#F09F9C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 61.6666H65L69.8366 73.7633C70.0386 74.2689 70.1137 74.8162 70.0553 75.3575C69.9969 75.8988 69.8068 76.4176 69.5016 76.8684C69.1964 77.3193 68.7855 77.6885 68.3046 77.9439C67.8238 78.1993 67.2877 78.3329 66.7433 78.3333H13.2566C12.7122 78.3329 12.1761 78.1993 11.6953 77.9439C11.2145 77.6885 10.8035 77.3193 10.4983 76.8684C10.1931 76.4176 10.0031 75.8988 9.94465 75.3575C9.88625 74.8162 9.96132 74.2689 10.1633 73.7633L15 61.6666Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61.6667C46.4434 61.6667 51.6667 56.4434 51.6667 50C51.6667 43.5567 46.4434 38.3334 40 38.3334C33.5567 38.3334 28.3334 43.5567 28.3334 50C28.3334 56.4434 33.5567 61.6667 40 61.6667Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 38.3333C44.6023 38.3333 48.3333 34.6023 48.3333 30C48.3333 25.3976 44.6023 21.6666 40 21.6666C35.3976 21.6666 31.6666 25.3976 31.6666 30C31.6666 34.6023 35.3976 38.3333 40 38.3333Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6866 43.4967L56.6666 40",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3134 43.4967L23.3334 40",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 10.8334C31.8876 10.8334 32.0996 10.9212 32.2559 11.0775C32.4122 11.2337 32.5 11.4457 32.5 11.6667",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8334 11.6667C30.8334 11.4457 30.9212 11.2337 31.0775 11.0775C31.2337 10.9212 31.4457 10.8334 31.6667 10.8334",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 12.5C31.4457 12.5 31.2337 12.4122 31.0775 12.2559C30.9212 12.0996 30.8334 11.8876 30.8334 11.6666",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 11.6666C32.5 11.8876 32.4122 12.0996 32.2559 12.2559C32.0996 12.4122 31.8876 12.5 31.6666 12.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10.8334C50.221 10.8334 50.433 10.9212 50.5893 11.0775C50.7455 11.2337 50.8333 11.4457 50.8333 11.6667",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1666 11.6667C49.1666 11.4457 49.2544 11.2337 49.4107 11.0775C49.567 10.9212 49.7789 10.8334 50 10.8334",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12.5C49.7789 12.5 49.567 12.4122 49.4107 12.2559C49.2544 12.0996 49.1666 11.8876 49.1666 11.6666",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8333 11.6666C50.8333 11.8876 50.7455 12.0996 50.5893 12.2559C50.433 12.4122 50.221 12.5 50 12.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19.1666C60.221 19.1666 60.433 19.2544 60.5893 19.4107C60.7455 19.567 60.8333 19.7789 60.8333 20",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1666 20C59.1666 19.7789 59.2544 19.567 59.4107 19.4107C59.567 19.2544 59.7789 19.1666 60 19.1666",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20.8333C59.7789 20.8333 59.567 20.7455 59.4107 20.5893C59.2544 20.433 59.1666 20.221 59.1666 20",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 20C60.8333 20.221 60.7455 20.433 60.5893 20.5893C60.433 20.7455 60.221 20.8333 60 20.8333",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 30.8334C66.8876 30.8334 67.0996 30.9212 67.2559 31.0775C67.4122 31.2337 67.5 31.4457 67.5 31.6667",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8334 31.6667C65.8334 31.4457 65.9212 31.2337 66.0775 31.0775C66.2337 30.9212 66.4457 30.8334 66.6667 30.8334",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 32.5C66.4457 32.5 66.2337 32.4122 66.0775 32.2559C65.9212 32.0996 65.8334 31.8876 65.8334 31.6666",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 31.6666C67.5 31.8876 67.4122 32.0996 67.2559 32.2559C67.0996 32.4122 66.8876 32.5 66.6666 32.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 19.1666C21.8876 19.1666 22.0996 19.2544 22.2559 19.4107C22.4122 19.567 22.5 19.7789 22.5 20",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8334 20C20.8334 19.7789 20.9212 19.567 21.0775 19.4107C21.2337 19.2544 21.4457 19.1666 21.6667 19.1666",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 20.8333C21.4457 20.8333 21.2337 20.7455 21.0775 20.5893C20.9212 20.433 20.8334 20.221 20.8334 20",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20C22.5 20.221 22.4122 20.433 22.2559 20.5893C22.0996 20.7455 21.8876 20.8333 21.6666 20.8333",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1666 28.3334C24.3876 28.3334 24.5996 28.4212 24.7559 28.5775C24.9122 28.7337 25 28.9457 25 29.1667",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 29.1667C23.3334 28.9457 23.4212 28.7337 23.5775 28.5775C23.7337 28.4212 23.9457 28.3334 24.1667 28.3334",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 30C23.9457 30 23.7337 29.9122 23.5775 29.7559C23.4212 29.5996 23.3334 29.3876 23.3334 29.1666",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.1666C25 29.3876 24.9122 29.5996 24.7559 29.7559C24.5996 29.9122 24.3876 30 24.1666 30",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8333 28.3334C55.6123 28.3334 55.4004 28.4212 55.2441 28.5775C55.0878 28.7337 55 28.9457 55 29.1667",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 29.1667C56.6667 28.9457 56.5789 28.7337 56.4226 28.5775C56.2663 28.4212 56.0544 28.3334 55.8334 28.3334",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8334 30C56.0544 30 56.2663 29.9122 56.4226 29.7559C56.5789 29.5996 56.6667 29.3876 56.6667 29.1666",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29.1666C55 29.3876 55.0878 29.5996 55.2441 29.7559C55.4004 29.9122 55.6123 30 55.8333 30",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 30.8334C13.5544 30.8334 13.7663 30.9212 13.9226 31.0775C14.0789 31.2337 14.1667 31.4457 14.1667 31.6667",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 31.6667C12.5 31.4457 12.5878 31.2337 12.7441 31.0775C12.9004 30.9212 13.1123 30.8334 13.3333 30.8334",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 32.5C13.1123 32.5 12.9004 32.4122 12.7441 32.2559C12.5878 32.0996 12.5 31.8876 12.5 31.6666",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 31.6666C14.1667 31.8876 14.0789 32.0996 13.9226 32.2559C13.7663 32.4122 13.5544 32.5 13.3334 32.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectQ4M);
export default __webpack_public_path__ + "static/media/prospect-q4-m.5c867b5e37db13922754c20bb4246962.svg";
export { ForwardRef as ReactComponent };